import DatePicker from "react-datepicker";
import './fieldDate.css'
import React, { useRef } from "react";
import DataDevis from '../../dataDevis';

export default (p) => {
    const {devis,changeParams,showValidate,focusError} = p.container
    const {notice} = p
    const value = devis.params[p.field]
    let message = devis.validateMessage(p.field)

    const ref = useRef()
    if ( message && !p.noCheck ) focusError(ref)
    if ( !showValidate ) message = undefined

    const label = p.label || devis.getLabel( p.field )
    return <>
        <h3>{label}</h3>
        {notice?<span className="notice">{notice}</span>:<></>}
        <div ref={ref} className={message?'invalidbox':''}>
            <DatePicker 
                placeholderText="00 / 00 / 0000" 
                dateFormat="dd/MM/yyyy" isClearable showYearDropdown 
                locale="fr" 
                scrollableYearDropdown={true}
                yearDropdownItemNumber={80}
                selected={ DataDevis.paramToDate(value) }
                onChange={(v)=>changeParams({[p.field]:DataDevis.dateToParam(v)})} />
        </div>
        {message?<div className="invalid">{message}</div>:''}
    </>
}
